import React, { useState, useEffect } from 'react';

interface EmailInputProps {
  email: string;
  onEmailChange: (value: string) => void;
  onValidation: (errors: string[]) => void;
}

const Email: React.FC<EmailInputProps> = ({ email, onEmailChange, onValidation }) => {
  const [emailError, setEmailError] = useState<string>('');
  const [touched, setTouched] = useState(false);

  const validate = () => {
    const errors: string[] = [];

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email.length > 2 && !emailRegex.test(email)) {
      errors.push("Ikke gyldig e-postadresse.");
    }
    setEmailError(errors[0]);
    onValidation(errors);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTouched(true);
    onEmailChange(e.target.value);
  };

  useEffect(() => {
    if (touched) {
      validate();
    }
  }, [email]);

  return (
    <div className="row mb-3">
      <label htmlFor="formEmail" id="FakturaadresseEpost" className="col-sm-2 col-form-label">Faktura</label>
      <div className="col-sm-5">
      <input
        type="email"
        id="FakturaadresseEpost"
        name="email"
        className="form-control"
        value={email}
        onChange={handleChange}
        placeholder="epost@firmanavn.no"
        required
      />
      </div>
      {emailError && <div className="text-danger mt-2">{emailError}</div>}
    </div>
  );
};

export default Email;